import { configReducer } from '../../store/config/config.reducer';
import { postPageReducer } from '../../store/template/postPage/postPage.reducer';
import {
  getAdSlots,
  getDfpProperty,
  getEdition,
  getHeaderBidderPublisherID,
  getLanguage,
  getPageType,
  getSiteName,
} from '../../store/config/config.selectors';
import {
  getArticleId,
  getBlockNames,
  getChannels,
  getCommercialTags,
  getContentTypesToQuantity,
  getCover,
  getCreatedAt,
  getDfpCategory,
  getMetadataAdsCategory,
  getNumberOfWordsTyped,
  getOwnerName,
  getOwnerUsername,
  getTags,
  getTitle,
} from '../../store/template/postPage/postPageKyiv/postPageKyiv.selectors';
import { PostPageComponent } from './PostPageKyivComponent';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
  GET_PAGE_DATA,
  GET_PALETTE_DATA,
  INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { formatDate, getCountryCode, getCoverType } from '../templates.utils';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { headerReducer } from '../../store/navigation/default/header/header.reducer';
import { menuReducer } from '../../store/navigation/default/menu/menu.reducer';
import { footerReducer } from '../../store/navigation/default/footer/footer.reducer';

export const rootReducer = {
  config: configReducer,
  footer: footerReducer,
  header: headerReducer,
  menu: menuReducer,
  template: postPageReducer,
  siteAnnouncement: announcementReducer,
};

const getCoreParams = (state: AppState) => ({
  siteName: getSiteName(state),
  property: getEdition(state),
  language: getLanguage(state),
  category: getMetadataAdsCategory(state),
  pageType: getPageType(state),
  adSlots: getAdSlots(state),
  headerBidderPublisherID: getHeaderBidderPublisherID(state),
  articleId: getArticleId(state),
  articleTemplate: getBlockNames(state),
  channels: getChannels(state),
  articleAuthor: getOwnerName(state),
  ownerUsername: getOwnerUsername(state),
  articleTitle: getTitle(state),
  articlePublicationTime: formatDate(getCreatedAt(state)),
  contentTags: getTags(state),
  mainMedia: getCoverType(getCover(state)),
  countryCode: getCountryCode(),
  commercialTags: getCommercialTags(state),
  dfpCategory: getDfpCategory(state),
  articleContentCount: getContentTypesToQuantity(state),
  articleWordCount: getNumberOfWordsTyped(state),
  dfpProperty: getDfpProperty(state),
});

export const PostPageKyiv = new TemplateRegistration()
  .setComponent(PostPageComponent)
  .setRootReducer(rootReducer)
  .setCoreParams(getCoreParams)
  .addClientAPIEvent(INJECT_VIDEO_LOGO)
  .addClientAPIEvent(GET_PAGE_DATA)
  .addClientAPIEvent(INJECT_ARTICLE_BLOCK_BY_INDEX_ARRAY)
  .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
  .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
  .addClientAPIEvent(GET_PALETTE_DATA)
  .build();
